export interface Translate {
  [key: string]: string;
}

export interface TranslateArray {
  [key: string]: Translate;
}

export const translations: TranslateArray = {
  ru: {
    competitor_info_dialog: 'Информация о участнике',
    lapInvalid: 'Круг не зачтен',
    lapValid: 'Круг зачтен',
    bestLap: 'Лучший круг',
    joker: 'Джокер',
    optionalLap: 'Не обязательная отметка',
    editedLap: 'Исправлено',
    timebar: 'КВ',
    custom_map_on_off: 'Показать/Скрыть свою карту',
    save_success: 'Сохранено удачно',
    custom_map: 'добавить свою карту',
    connect: 'Соединение восстановлено',
    wrongdate: 'Неверная дата. Формат даты: YYYY-MM-DD hh:mm:ss',
    disconnect: 'Потеряно соединение с сервером',
    distance: 'Пройденное раcстояние',
    diff_speed: 'Средняя скорость',
    max_speed: 'Максимальная скорость',
    show_track: 'Показать трек',
    hide_track: 'Скрыть трек',
    no_start_man: 'Не стартовал',
    no_start_woman: 'Не стартовалa',
    no_tracker: 'Нет трекера',
    waiting_param: 'Параметры ожидаются',
    select_class: 'Выберите класс',
    laps: 'Круги',
    time: 'Время',
    empty_list: 'Список пуст',
    start: 'Старт',
    common_time: 'Общее время',
    best_lap: 'Лучший круг',
    track_length: 'Видимый трек',
    speed_limit: 'Лимит скорости',
    min: 'мин',
    all: 'Весь',
    header_all: 'Все',
    track_resume_online: 'Прямая трансляция',
    track_resume_history: 'Просмотр записи',
    track_start_real: 'Реальное время старта',
    track_start_massive: 'От одного времени старта',
    show_details: 'Показать подробнее',
    hide_details: 'Скрыть подробности',
    timePoint: 'отметки',
    timePrevPoint: 'от предыдущей отметки',
    timeStartPoint: 'от начала круга',
    timeStartUser: 'от старта участника',
    timeDeltaLeader: 'отставания от лидера',
    not_selected: 'Не выбрано',
    saved: 'Сохранено',
    restore_mark_question: 'Восстановить метку?',
    delete_mark_question: 'Удалить метку?',
    penalty_and_dnf: 'Сход и пенализация',
    penalty: 'Пенализация',
    dnf: 'Сход',
    descent_0: 'Не выбрано',
    descent_1: 'Нет схода',
    descent_2: 'Дисквалификация',
    descent_3: 'Вышло время',
    descent_4: 'Поломка',
    descent_5: 'Травма',
    descent_6: 'Не финишировал',
    dnf_reason: 'Причина схода',
    marshal_num: 'Номер маршала',
    dateTimeMark: 'Дата, время отметки',
    time_from_previous_mark: 'Время от предыдущей отметки',
    created: 'Создано',
    edited: 'Редактировано',
    deleted: 'Удалено',
    datauser: 'Данные по участнику №',
    speed: 'Скорость',
    distance_value: 'км',
    speed_value: 'км/ч',
    mark_date: 'Дата трекера',
    mark_time: 'Время трекера',
    age: 'лет',
    month: 'мес.',
    racetime: 'Время гонки',
    lastpoint: 'Последняя отметка',
    gpstracker: 'GPS трекера',
    add_new_org_error: 'Сначала сохраните гонку',
    save_race_before_add_class: 'Сначала сохраните гонку, чтобы добавлять классы',
    save_race_before_add_marshal: 'Сначала сохраните гонку, чтобы добавлять маршалов',
    callInfo: `*Звонок бесплатный, он будет сброшен сразу при дозвоне, это нормально. У вас есть 5 минут на звонок, после этого нужно будет начать процедуру заново.`,
    close_race_confirm: 'Закрыть соревнование? После этого редактирование результатов станет невозможным, участникам запишуться в их зал славы результаты и им будут отправлены СМС с просьбой оценить соревнование',
    sms_confirm_query: 'СМС будет отправлена $1 участникам, ваш текст содержит $2 символов, в 1 смс помещается $3, т.е. каждому участнику будет отправлено $4 смс, стоимость отправки $5 х $6 х $7 = $8 рублей, отправить? Отправка займет $9 секунд',
    application_text: `Я, нижеподписавшийся, принимаю требования Положения, Регламента, Спортивного кодекса Федерации мотоциклетного спорта России (Далее по тексту МФР) и Правил соревнований, других нормативных документов МФР и законодательства РФ, обязуюсь строго соблюдать их. Подтверждаю, что у меня нет медицинских противопоказаний для занятий спортом, я не принимаю наркотики и не злоупотребляю алкоголем. В случае получения травмы или заболевания, я разрешаю медицинскому персоналу оказать необходимую медицинскую помощь и сообщить соответствующую информацию в компетентные органы и заинтересованным лицам.  Подтверждаю, что данные, указанные мною в заявке соответствуют действительности. Заявленные мотоциклы соответствуют техническим требованиям. Настоящим подтверждаю, что имею отрицательный тест на COVID-19 методом полимеразной цепной реакции, полученный не ранее 3х календарных дней до начала мероприятия. Я, даю свое согласие на обработку персональных данных в соответствии с законом 152-фз.`,
    'finish/mark': 'Финиш/',
    tech_section: 'Технологии, используемые для отметки участников соревнования',
    youisnotmember: 'Вы не являетесь участником этого соревнования, только участники могут оставлять отзывы',
    class_numbers_about_title: 'Оставьте поля пустыми, если допустимы любые номера',
    class_numbers_by_org_about: 'Здесь вы можете задать правила присвоения номеров участникам. Если вы отметите "Номера присваиваются организатором", то участники не смогут самостоятельно выбирать номера при онлайн регистрации через сайт, но организатор сможет по прежнему сможет назначать им номера в программе на смартфоне. <br> Установка диапазона влияет и на онлайн регистрацию на сайте и на работу программы на смартфоне - участники и организаторы смогут выбирать номер только из указанного  для данного класса диапазона',
    class_marshals_points_about: 'Нажмите на кнопку с гаечным ключом, чтобы выбрать отметки маршалов в диалоговом окне, если хотите редактировать строку отметок вручную, нажмите на иконку карандаша (вы должны знать и аккуратно соблюдать формат строки в этом случае)',
    class_finish_all_about: 'Отметка "Финишировать всех после лидера" означает, что после финиша лидера, все остальные участники должны финишировать, закончив свой очередной круг, несмотря на остальные условия',
    class_control_time_about: 'Отметьте переключатель, если хотите отсчитывать время гонки до закрытия финиша от старта первого участника в классе; оставьте неотмеченным, если хотите считать контрольное время для каждого участника от его старта',
    class_control_time: 'Отсчитывать контрольное время соревнования от старта первого участника в этом классе',
    class_finish_minutes_about: 'Время закрытия финиша в минутах от старта первого участника класса (или для каждого участника - в зависимости от положения переключателя ниже) - по окончанию этого времени программа будет предупреждать, что время финиша закрыто, но отметки будут записываться, но не будут учитываться в итоговом результате',
    class_marshal_about: 'Используется, когда маршал отмечает участника (в конце круга или на дистанции) для предотвращения дублированных отметок',
    class_finish_conditions_about: 'Указано время соревнования, круги не заполнены - гонка идет заданное время, победитель тот, кто пройдет больше кругов за минимальное время, но не меньше чем заданное. Финиш участникам будет дан после того, как лидер закончит круг ПОСЛЕ окончания установленного времени. Указаны круги, время пустое - соревнование длится заданное количество кругов и победитель тот, кто пройдет это количество кругов за минимальное время. <br>Указано и время соревнования и круги - участники гоняются заданное время, когда лидер проходит первый круг после окончания указанного времени, то участники должны еще гоняться указанное число кругов', class_allowable_age_about: 'Оставьте поля пустыми, если допускается любой возраст или заполните только одно поле, для проверки старше/младше соотвественно',
    areyousure_delete_mashal: 'Вы уверены, что хотите удалить маршала?',
    multistage_annotation: 'Если включено, то программа даст возможность сформировать итоговые результаты по нескольким этапам, например Пролог, 1 гоночный день, 2 гоночный день, или первый заезд, второй заезд',
    info_field_annotation: 'Это название поля будет показано участникам в онлайн регистрации и результатах дополнительной информацией о регистрации - например марка мотоцикла, на котором выступает участник',
    totalsCountBy: 'Считать сводные результаты по сумме времени (если не отмечено - по таблице очков)',
    applicationText: 'Текст, который будет отображаться внизу бланка заявки для участников',
    partialLapCountMethod: 'Учитывать незаконченный последний круг до последнего пройденного маршала при расчете результатов',
    needVerifiedEmail: 'Требуется подтвердить почту и указать пинкод отправленный на неё',
    emailInfoInit: 'Вам придет код на почту, который нужно будет ввести тут',
    sendToEmail: 'Отправить на почту код',
    email_input: 'Электронная почта',
    error_max_competitors_in_class: 'В этот класс уже зарегистрировано максимальное количество участников - $1 из $2 допустимых',
    error_max_competitors_in_race: 'В соревновании уже зарегистрировано максимальное количество участников - $1 из $2 допустимых',
    error_answer_obligatory: 'Ответ на этот вопрос обязателен',
    no_server_connection: 'Нет связи с сервером, попробуйте обновить страницу',
    deleted_from_org: 'Пользователь удален из организаторов',
    delete_from_org: 'Удалить выбранного пользователя из организаторов?',
    delete_from_org_self: 'Вы уверены, что хотите удалить себя из организаторов? Вы не сможете в дальнейшем редактировать соревнование',
    select_org_role: 'Выберите роль организатора',
    select: 'Выберите',
    owner: 'Владелец',
    main_org: 'Главный организатор',
    judge: 'Судья',
    marshal: 'Маршал',
    role: 'Роль',
    is_org: 'Права организатора',
    admin: 'Права администратора программы',
    beta_tester: 'Бета-тестер',
    required_field: ' - обязательно',
    required_field_annotation: '* - обязательно для заполнения',
    profileTypeAbout: 'При открытом профиле зрители смогут видеть ваши фотографии из галереи, информацию, которую вы напишете о себе, возраст',
    required_file: 'обязательно для заполнения',
    saving: 'Сохраняется...',
    valid: 'Проверено',
    examination: 'На проверке',
    add: 'Добавить',
    image: 'Изображение',
    select_my_files: 'Выберите файл из профиля',
    select_user_files: 'Файл из профиля',
    new_user_file: 'Новый файл',
    user_form_data_error: 'Ошибка при сохранении профиля',
    add_org: 'Добавить в орги',
    add_reg: 'Зарегистрировать',
    add_to_crew: 'Добавить в экипаж',
    delete_from_crew: 'Удалить из экипажа',
    empty_class: 'Нет подтвержденных участников',
    invalidFileSizeMessageSummary: '{0}: Неверный размер файла',
    invalidFileTypeMessageDetail: 'Разрешенные типы файлов: {0}',
    invalidFileLimitMessageSummary: 'Превышено максимальное количество файлов',
    invalidFileLimitMessageDetail: 'Лимит файлов {0} не более',
    invalidFileTypeMessageSummary: '{0} неверный тип файла',
    invalidFileSizeMessageDetail: 'Максимальный размер файла для загрузки {0}',
    competitors: 'Участники',
    profile_edit: 'Изменить',
    profile_cancel: 'Отменить',
    req_gender: 'Участник не подходит в этот класс по полу',
    phone_crew_format: 'Формат ввода номера телефона',
    error_age: 'Участник не подходит в этот класс по возрасту',
    error_reg_info: ' - Укажите регистрационную информацию',
    error_document: ' - Добавьте файл',
    error_number: ' - Укажите бортовой номер',
    error_password_short: ' - Слишком короткий пароль',
    error_info_large: ' - Слишком большая доп. информация',
    error_fio_empty: ' - Укажите ФИО',
    error_phone_empty: ' - Укажите номер телефона',
    error_fio: ' - ФИО должно начинаться с больших букв ',
    error_city: ' - Укажите Город',
    error_birthday: ' - Укажите дату рождения',
    error_birthday_date: ' - Неправильная дата рождения',
    error_password_missmatch: ' - Введенные пароли не совпадают',
    error_password: ' - Ваш пароль слишком короткой. Измените его',
    error_insurance: ' - Ваша страховка просрочена',
    error_citizenship: ' - Укажите гражданство',
    error_email: ' - неверный формат адреса',
    crew_competitors_need_reg: '*Зарегистрируйтесь для активации поля',
    crew_competitors_title: 'Участники экипажа',
    orgs_title: 'Организаторы',
    number: 'Номер',
    reg_saved: 'Вы зарегистрированы',
    reg_changed: 'Данные регистрации изменены',
    reg_class_changed: 'Класс регистрации изменен',
    reg_need_confirm: 'Ваша заявка на регистрацию принята, вы появитесь в списках зарегистрированных после оплаты и проверки документов организатором',
    are_sure: 'Вы уверены в смене класса?',
    confirm: 'Подтверждение',
    reg_data_is_deleted: 'Регистрационные данные удалены',
    information: 'Информация',
    change_reg: 'Изменить регистрацию',
    change_reg_crew: 'Изменить регистрацию и экипаж',
    del_reg: 'Удалить регистрацию',
    number_is_wrong: 'номер нарушает ограничение класса',
    number_is_busy: 'номер уже занят',
    info_field_race: 'Инф о регистрации',
    loading_race: 'Загрузка гонки',
    register: 'Форма регистрации',
    register_menu: 'Зарегистрироваться',
    no_places: 'В этом классе не осталось свободных слотов для регистрации',
    helper_crew_class: 'Экипажи из %1% участников могут регистрироваться в этот класс',
    helper_crew_class_members_range: 'Экипажи от %1% до %2% участников могут регистрироваться в этот класс',
    helper_numbers_range: 'Допустимые номера %1% - %2%',
    s_permitted_min_age: 'Минимальный возраст в этом классе: %1%',
    s_permitted_max_age: 'Максимальный возраст в этом классе: %1%',
    s_permitted_age_range: 'Возрастной диапазон в этом классе: %1% - %2%',
    s_any_gender: 'Участник любого пола может зарегистрироваться в этот класс',
    s_only_male: 'Только мужчины могут зарегистрироваться в этот класс',
    s_only_female: 'Только женщины могут зарегистрироваться в этот класс',
    s_any_age_permitted: 'Участники любого возраста могут зарегистрироваться в этот класс',
    s_finish_after_leader: 'Финишировать всех после лидера',
    s_fin_close_time_description: 'Закрытие финиша через %1% после старта первого участника класса',
    s_fin_close_time_description_every: 'Закрытие финиша через %1% после старта каждого участника класса',
    s_checkpoints_description: 'Маршалы, через которых проходит трасса: %1%',
    add_new_competitor: 'Участник с таким номером телефона не найден. Зарегистрировать нового?',
    add_new_competitor_complete: 'Участник добавлен в экипаж',
    add_new_org_complete: 'Пользователь добавлен в организаторы',
    new_competitor_dialog_title: 'Добавление нового участника',
    deleted_from_crew: 'Участник удален из экипажа',
    crew_is_full: 'Экипаж заполнен',
    warning: 'Внимание',
    hint_crew: '* Введите номер телефона и нажмите кнопку для добавления участника экипажа. Если такого пользователя нет в базе, то программа предложит его создать.',
    hint_add_reg: '* Введите номер телефона и нажмите кнопку для добавления участника. Если такого пользователя нет в базе, то программа предложит его создать.',
    hint_add_org: '* Введите номер телефона и нажмите кнопку для добавления организатора. Если такого пользователя нет в базе, то программа предложит его создать.',
    s_minLapTime: 'Мин время круга %1% сек',
    race_time: 'Длительность гонки',
    s_lap_one: '%1% круг',
    s_laps_few: '%1% круга',
    s_laps_many: '%1% кругов',
    s_laps_other: '%1% кругов',
    s_numbers_choosen_by_competitors: 'Участники сами выбирают номера',
    s_numbers_assigned_org: 'Номера присваиваются организатором',
    s_numbers_min_max: 'Разрешены номера из диапазона %1% - %2%',
    s_numbers_assing_by_org: 'Номера присваиваются организатором',
    busy_numbers: 'Занятые номера',
    bike: 'Девайс',
    no_competitors: 'Никого нет в этом классе гонки',
    reg_in_class: 'Зарегистрироваться в этот класс',
    required_ruid: 'Укажите UID гонки',
    sport_title: 'Спортивные звания',
    team: 'Команда',
    dob: 'Дата рождения',
    city: 'Город',
    internationalName: 'Международное имя',
    name: 'ФИО',
    motto: 'Девиз',
    citizenship: 'Гражданство',
    profileDataConfirmed: 'Данные профиля подтверждены',
    profileDataDontConfirmed: 'Данные профиля не подтверждены',
    profileOpened: 'Профиль открыт - зрители смогут видеть ваши фотографии из галереи (кроме помеченых, как приватные), информацию, которую вы напишете о себе, возраст',
    profileClosed: 'Профиль закрыт - зрители не увидят ваши фотографии из галереи, информацию, которую вы напишете о себе, возраст',
    editorAvatar: 'Редактор аватара',
    profileType: 'Профиль открытый?',
    emaileConfirmed: 'Email подтвержден',
    phoneConfirmed: 'Телефон подтвержден',
    checkPhone: 'Требуется подтвердить номер телефона',
    checkEmail: 'Требуется подтвердить электронную почту - вам на указанную почту было отправлено письмо, зайдите в него и нажмите там на ссылку',
    emailSended: 'Письмо отправлено',
    emailNotSended: 'Письмо не отправлено',
    phone_is_busy: 'Другой пользователь зарегистрирован с этим номером телефона. Если это ваш номер телефона, не создавайте новый профиль, войдите с этим номером. Вы можете использовать кнопку Получить пароль при входе, если не помните его. В случае затруднений, напишите разработчикам на reg@marshalone.com',
    exitConfirm: 'Выйти?',
    wrongFormat: 'Неверный формат телефона.',
    password: 'Пароль',
    passwordRe: 'Пароль повторно',
    undefGender: 'Не определено',
    manGender: 'Мужчина',
    womanGender: 'Женщина',
    myFoto: 'Фото',
    errorFile: 'Ошибка загрузки файла',
    unsupportedFileType: 'Неподдерживаемый тип файла',
    inputIsEmpty: 'Поле не заполнено',
    error: 'Ошибка',
    addLink: 'Добавить',
    inputLink: 'Укажите ссылку',
    myLinks: 'Ссылки',
    myImages: 'Изображения',
    myDocuments: 'Документы',
    insuranceNo: 'Номер страховки',
    insurance: 'Дата страховки',
    all_race: 'Все гонки',
    all_track: 'Весь',
    org: 'Организую',
    comp: 'Участвую',
    competitor: 'Участник',
    organisator: 'Организатор',
    phone: 'Телефон',
    email: 'Электронная почта',
    dateOfBirdth: 'Дата рождения',
    gender: 'Пол',
    aboutOfMe: 'Информация о себе',
    auth: 'Войти',
    exit: 'Выход',
    profile: 'Профиль',
    save: 'Сохранить',
    unsaved: 'Не сохранено',
    cancel: 'Отмена',
    back: 'Назад',
    list: 'Список гонок',
    doorg: 'Стать организатором',
    images: 'Изображения',
    documents: 'Документы',
    links: 'Ссылки',
    not_found: 'Гонок не найдено за указанный период. Выберите другие даты в календаре.',
    private: 'Приватная',
    regisclosed: 'Регистрация закрыта',
    langs: 'Выберите язык',
    yes: 'Да',
    no: 'Нет',
    loading: 'Загрузка...',
    result: 'Результаты',
    map: 'Карта',
    main: 'MarshalOne',
    dates_filter: 'Период дат',
    types_filter: 'по типу',
    void: 'void',
    emailIsSucces: 'Емейл успешно подтвержден!',
    profileTypeOn: 'Открыть профиль',
    profileTypeOff: 'Закрыть профиль',
    ok: 'ОК',
    getPassword: 'Получить пароль',
    confirmCallNumber: 'Подтвердить по входящему звонку',
    confirmCallInit: 'Подтвердить по исходящему звонку',
    confirmPincode: 'Подтвердить по коду из смс',
    getCallNumber: 'Войти по входящему звонку',
    getCallInit: 'Войти по исходящему звонку',
    getPincodeEmail: 'Войти по коду из почты',
    getPincode: 'Войти по коду из смс',
    enter: 'Войти по паролю',
    noauth: 'Вход только по звонку',
    pincode: 'Пинкод',
    success: 'Успешно',
    wrongPhone: 'Неверный формат телефона',
    wrongPassword: 'Неверные данные',
    info: 'Внимание',
    call: 'Для подтверждения вашего номера телефона позвоните на номер $1 до $2',
    user_created: 'Пользователь создать, требуется подтверждение через звонок',
    next: 'Далее',
callInfoInit: 'Вам поступит звонок, отвечать на него не нужно, вам нужно ввести последние 4 цифры входящего номера в поле "Пинкод".',
    errorCallInit: 'Ошибка сервера при вызове',
    callCheckInfo: 'Для входа позвоните с вашего телефона на номер $1. Звонок бесплатный (в том числе из-за рубежа), после звонка вы будете автоматически авторизованы. На звонок у вас есть $2 минут.',
    callCheckStatus: 'Проверить статус звонка',
    callCheckInfoHint: 'Нажмите кнопку "Войти по исходящему звонку" и позвоните с вашего телефона на указанный номер - ваш номер будет подтвержден автоматически. Звонок бесплатный, даже из-за рубежа. После звонка вы будете автоматически авторизованы.',
    waitEmail: 'Вам на почту придет пинкод, который нужно будет ввести в поле "Пинкод"',
    waitCall: 'Вам поступит звонок, отвечать на него не нужно, вам нужно ввести последние 4 цифры входящего номера в поле "Пинкод". Ожидайте вызова.',
    waitSmsPass: 'Пароль отправлен на ваш номер телефона по СМС. Ожидайте сообщения.',
    passwordInfoInit: 'В случае если вы забыли свой пароль вы можете получить его на телефон или емейл',
    user_form_fill_error: 'Заполните все обязательные параметры!',
    user_form_fill_error_city: 'Неверно заполнен город - вводите название города в текстовом поле и затем выберите из предложенного списка!',
    delete_attachment: 'Удаление приложения',
    delete_images: 'Удалить изображение',
    delete_files: 'Удалить документ',
    delete_links: 'Удалить ссылку',
    attachment_params: 'Параметры приложения',
    description_hint: 'Описание',
    valid_until: 'Действует до',
    other: 'Другое',
    error_date: 'Неправильная дата',
    private_label: 'Приватный файл',
    private_helper: 'Если флажок включен, то этот файл сможете увидеть только вы или организатор соревнования, зрители не смогут его увидеть',
    attachment_doc_type_helper: 'Если выбрать вид документа и указать срок его действия, то при регистрации на соревнования этот документ будет автоматически прикрепляться, если этот тип документов требуется для регистрации',
    doc_type_label: 'Тип документа',
    register_yourrself_first_hint: 'Сначала зарегистрируйтесь сами, а затем добавьте членов экипажа',
    add_crew_members_now: 'Теперь вы можете добавить членов экипажа',
    female: 'Женский',
    male: 'Мужской',
    close: 'Закрыть',
    competitor_hof_dialog: 'Прошедшие гонки',
    map_off: 'Списком',
    map_on: 'На карте',
    max_competitors: 'Максимум участников в соревновании',
    helper_max_competitors_reason: 'Если указано значение больше нуля, то оно задает максимальное количество участников, которые могут зарегистрироваться в соревнование через сайт. На добавление участников организатором это значение не влияет - можно добавить и больше, чем указано. Участники экипажей не учитываются в расчете',
    max_competitors_class: 'Максимум участников в этом классе',
    helper_max_competitors_class_reason: 'Если указано значение больше нуля, то оно задает максимальное количество участников, которые могут зарегистрироваться в этот класс через сайт. На добавление участников организатором это значение не влияет - можно добавить и больше, чем указано. Участники экипажей не учитываются в расчете',
    question: 'Вопрос',
    poll_section: 'Анкета (опрос) участника',
    poll_annotation: 'Вопросы, которые вы впишете здесь будут показаны участнику в момент регистрации. При отметке у вопроса Обязательно, участник не сможет зарегистрироваться, пока не заполнит ответ. Эти вопросы могут использоваться для сбора дополнительной информации об участниках для комментатора, например Ваши ожидания от гонки? или для получения информации для организатора, например, Вам на дозаправке нужен бензин с маслом или без?',
    s_dont_count_first_lap_as_best: 'Не учитывать первый круг как лучший (если отмечено, то первый круг не будет участвовать в расчете лучшего круга, например, если он длиннее или короче за счет расположения старта)',
    location_description: 'Описание проезда к месту старта или лагерю',
    open_admin_console: 'Открыть консоль админа',
    location_annotation: 'Перетащите маркер или нажмите на точку старта или лагеря соревнования',
    orgs_list: 'Список организаторов',
    race_copy_name: '(Копия)',
    copy_race: 'Копировать',
    copy_race_no_docs_no_competitors: 'Копировать без участников',
    copy_race_no_docs_competitors: 'Копировать c участниками, без документов и оплаты',
    copy_race_docs_competitors: 'Копировать с участниками, документами и оплатой',
    copy_race_confirm: 'Создать копию выбранного соревнования?',
    delete_race: 'Удалить выбранное соревнование? Удалятся все результаты, регистрации, команды!',
    delete_race_confirm: 'Вы не передумали удалять соревнование? Нажмите Нет, если все еще хотите ее удалить.',
    create_new: 'Создание',
    create_new_race: 'Создать новое соревнование?',
    docType: 'Тип документа',
    used: 'Требовать',
    obligatory_at_reg: 'Обязательно',
    wrong_finish_conditions: 'Как минимум одно из значений - Время гонки или Круги должно быть заполнено',
    wrong_members_range: 'Неверные значения количества членов экипажа',
    wrong_numbers_range: 'Неверный диапазон номеров',
    wrong_age_range: 'Неверный диапазон возраста',
    sort_position: 'Позиция в списке',
    form_fill_error: 'Заполните все обязательные параметры!',
    form_fill_error_city: 'Неверно заполнен город - вводите название города в текстовом поле и затем выберите из предложенного списка!',
    obligatory_param: 'обязательные данные',
    wrong_date: 'некорректная дата',
    user_payed: 'Оплата принята',
    doc_not_accepted: 'не принят',
    docs_valid: 'Регистрация подтверждена',
    yourated: 'Вы уже оценили это соревнование',
    rateisadded: 'Ваша оценка добавлена',
    rateCategory0: 'Трасса',
    rateCategory1: 'Атмосфера праздника',
    rateCategory2: 'Комфорт для участников',
    rateCategory3: 'Судейство',
    tableEmpty: 'нет записей',
    rate: 'Оценка',
    comment: 'Комментарий',
    rateComments: 'Комментарии участников гонки',
    rateComment: 'Оставьте свой комментарий к оценке',
    search_placeholder: 'Номер, имя участника для поиска',
    competitors_list: 'Список всех участников в порядке регистрации',
    new_class: 'Добавление нового класса',
    class_numbers_max: 'По номер',
    class_numbers_min: 'C номера',
    attachments_new_user_hint: "После сохранения профиля вы можете зайти в него снова и прикрепить изображения, документы и ссылки, которые смогут увидеть зрители и организаторы, а также при регистрации на соревнование вам проще будет загружать требуемые организатором документы",
    class_numbers_rules: 'Правила присвоения номеров',
    class_numbers_about: 'Диапазон номеров для этого класса',
    class_numbers_by_org: 'Номера присваиваются организатором',
    class_marshals_points: 'Маршалы, через которых проходит трасса',
    class_finish_all: 'Финишировать всех после лидера',
    class_finish_minutes: 'Время закрытия финиша в минутах',
    class_min_lap_second: 'Минимальное время круга',
    class_lap_count: 'Круги',
    class_all_minutes: 'Время соревнования в минутах',
    class_finish_conditions: 'Условия финиша',
    class_crews_max_count: 'Макс в экипаже',
    class_crews_min_count: 'Мин в экипаже',
    class_crew_active: 'Участвуют экипажи',
    class_age_max: 'Макс возраст',
    class_age_min: 'Мин возраст',
    class_allowable_age: 'Допустимый возраст',
    class_required_competitor: 'Требования к участникам',
    class_gender: 'Разрешенный пол',
    class_about: 'Описание: взнос, требуемые документы и т.п.',
    class_name: 'Название класса',
    notsaved: 'Не сохранено',
    addClass: 'Добавить класс',
    areyousure: 'Вы уверены что хотите удалить класс соревнования?',
    classes: 'Классы',
    metadata: 'Дополнительные файлы',
    block: 'Требуется сохранить соревнование перед загрузкой файлов',
    race_deleted: 'Соревнование удалено',
    race_copied: 'Соревнование скопированно',
    delete: 'Удалить',
    change: 'Изменить',
    edit: 'Редактировать',
    logo: 'Логотип соревнования / организатора',
    main_foto: 'Картинка соревнования (афиша)',
    about: 'Описание соревнования для зрителей и участников',
    useNfc: 'NFC',
    useRfid: 'RFID',
    useGps: 'GPS трекеры',
    useChronoTags: 'Хронометраж',
    hasTeamStandings: 'Есть командный зачет',
    rules_section: 'Правила подсчета результатов',
    multistage: 'Многоэтапное соревнование',
    registration_rules_section: 'Правила регистрации',
    allow_equal_numbers: 'Разрешить одинаковые номера в разных классах',
    has_absolute_standing: 'Есть абсолютный зачет',
    s_by_best_lap_rule: 'Считать результаты по лучшему кругу',
    show_mills_results: 'Показывать миллисекунды в результатах',
    s_location: 'Расположение старта или лагеря',
    coordinates: 'Координаты: ',
    infoFieldName: 'Название поля регистрации',
    type_sport: 'Вид спорта',
    time_zone: 'Часовой пояс',
    date: 'Дата',
    title: 'Название',
    race_changes: 'Изменения',
    notfound: 'Соревнование не найдено за указанный период. Выберите другие даты в календаре.',
    list_registered_user: 'Список участников',
    change_register: 'Изменить регистрацию',
    create_race: 'Добавить соревнование',
    current_day: 'Сегодня',
    class_deleted: 'Класс удален',
    marshals: 'Маршалы',
    add_marshal: 'Добавить маршала',
    mashal_data: 'Данные маршала',
    points: 'Очки',
    radius: 'Радиус взятия КП',
    finish: 'Финиш',
    marshal_deleted: 'Маршал удален',
    no_data: 'Нет данных',
    download_questions_csv: 'Скачать ответы опроса CSV',
    application_form_autosport: 'Заявка автоспорт',
    upload_results_from_file: 'Загрузить результаты из файла',
    tags_panel: 'Трекеры, датчики',
    not_confirmed: 'Не подтверждена регистрация',
    org_comment: 'Заметки орга',
    form_mfr_licenses: 'Сформировать лицензии МФР',
    participation_in_races_csv: 'Список участия в гонках',
    sport_subtype: 'Офиц название спорт дисциплины',
    mfr_license_c: 'Лицензия МФР С',
    report_trackers: 'Список выданных трекеров',
    report_tags: 'Список выданных датчиков',
    report_competitors_list_full: 'Список зарегистрированных участников',
    report_overall_results: 'СВОДНЫЙ ПРОТОКОЛ ЛИЧНЫХ РЕЗУЛЬТАТОВ',
    report_personal_results: 'ПРОТОКОЛ ЛИЧНЫХ РЕЗУЛЬТАТОВ',
    report_tech_committee: 'ПРОТОКОЛ ТЕХНИЧЕСКОЙ КОМИССИИ',
    report_medical_committee: 'ПРОТОКОЛ МЕДИЦИНСКОЙ КОМИССИИ',
    report_admitted: 'ПРОТОКОЛ ДОПУЩЕННЫХ УЧАСТНИКОВ',
    report_bib: 'Ст.№',
    report_position: 'Место',
    report_competitor_name: 'ФИО участника',
    report_competitor_birth_date: 'Дата рождения',
    report_phone: 'Телефон',
    report_email: 'Email',
    report_starting_fee: 'Оплата',
    report_reg_confirmed: 'Рег подтв',
    report_reg_time: 'Время регистрации',
    report_class: 'Класс',
    report_sport_title: 'Спортивное звание, разряд',
    report_insurance_no_summ: '№ и сумма страхового полиса',
    report_sport_license: '№ лицензии',
    report_competitor_signature: 'Подпись, удостоверяющая знание правил соревнваний и спортивного кодекса',
    report_tech_confirm: 'Допуск тех комиссара',
    report_blood_pessure: 'Показания давления',
    report_name_team_city: 'ФИО участника, команда, город',
    report_team_city: 'Команда, город',
    report_team: 'Команда',
    report_city: 'Город',
    report_time_start: 'Время старта',
    report_time_fin: 'Время финиша',
    report_time_race: 'Время прохождения дистанции',
    report_laps: 'Зачтенное количество кругов',
    report_run: 'заезд',
    report_run_position: 'место',
    report_run_points: 'очки',
    report_run_time: 'время',
    report_best_lap_time: 'Время лучшего круга',
    report_total_time: 'Итого время',
    report_total_points: 'Всего очков',
    report_tracker: 'Трекер',
    report_tag: 'Номер датчика',
    report_device_returned: 'Дата время возврата',
    report_total_devices: 'Всего устройств выдано',
    report_main_org: 'Руководитель гонки ФИО, подпись',
    report_main_judge: 'Главный судья',
    report_secretary: 'Главный секретарь',
    report_main_tech: 'Председатель технической комиссии',
    report_main_medic: 'Главный врач',
    report_rules: 'Победитель определяется по большей сумме очков при максимуме $1 очков за заезд, при равенстве очков - по количеству лучших мест, при равенстве - $2',
    report_rules_by_best_lap: 'Победитель определяется по лучшему кругу из всех заездов',
    report_rules_by_time: 'Победитель определяется по наименьшей сумме времени при равной пройденой дистанции',
    add_competitor: 'Добавить участника',
    del_time: 'Удаления',
    deleted_reg: 'Удаленные',
    statistic: 'Статистика',
    unsuccess_registrations: 'Неудачные регистрации',
    position: 'позиция',
    change_registration: 'Изменение регистрации',
    delete_number_confirm: 'Удалить стартовый номер у этого участника?',
    delete_tag_confirm: 'Удалить привязку датчика хронометража у этого участника?',
    assign_numbers: 'Присвоить номера по времени регистрации',
    assign_numbers_within_class: 'в пределах каждого класса',
    assign_numbers_across_all: 'сквозная нумерация по всем классам',
    numbers_assigned: 'Номера присвоены',
    numbers_deleted: 'Номера удалены',
    delete_numbers: 'Удалить номера',
    delete_numbers_confirm: 'Удалить присвоенные номера у всех участников выбранного класса?',
    totals: 'Итого',
    competitors_totals: 'Участников: ',
    birthdate: 'Дата рожд',
    reg_info: 'Инф о регистрации',
    reg_time: 'Время регистрации',
    start_fee: 'Взнос',
    docs: 'Док',
    gps_tracker: 'Трекер',
    chrono_tag: 'Датчик',
    race_state_0: 'Регистрация открыта',
    race_state_1: 'Регистрация закрыта',
    race_state_2: 'Соревнование стартовало',
    race_state_3: 'Соревнование закрыто',
    race_state: 'Состояние соревнования',
    data_to_clipboard: 'Данные скопированны в буффер обмена',
    confirm_delete_competitor: 'Удалить регистрацию участника $1? Это действие нельзя будет отменить!',
    delete_competitor: 'Удалить участника',
    doc_check_header: 'Проверка документов',
    showOnlyConfirmed: 'Показывать в списке зарегистрированных на сайте только участников с подтвержденной регистрацией и оплатой',
    no_document: 'Документы не загружены',
    reason: 'Причина',
    allDocumentsValid: 'Регистрация подтверждена',
    save_error: 'Ошибка сохранения',
    change_start_fee: 'Взнос',
    notFoundCompetitorByNumber: 'Не найдено участника по указанному номеру',
    loadingDataReport: 'Формирование отчета...',
    nopenalty: 'Нет нарушений в этом круге',
    newVersion: 'Новый вид результатов',
    oldVersion: 'Результаты в таблице',
    DOCUMENTS: 'Документы',
    PROGRESS: 'Прогресс',
    PROGRESSV2: 'Результаты',
    race: 'Гонка',
    class: 'Класс',
    classCopy: 'Копировать UID гонки',
    classCopyLink: 'Копировать ссылку на класс',
    progress: 'Результаты',
    document: 'Документы',
    timeDeltaLider: 'отставания от лидера',
    FIO: 'Участник',
    exportCSV: 'Экспорт в csv',
    infoErrors: 'Информация по штрафам круга',
    FIO1: 'участника',
    editLap: 'Редактирование круга',
    lapParams: 'Параметры класса',
    finishAfterLeader: 'Финишировать всех после лидера',
    finishing: 'финишировать',
    isntfinishing: 'не финишировать',
    lapsComment: 'Отметки на круге',
    jokerInfo: '(штраф - не зачет круга)',
    lapFinished: 'отметка круга/финиш',
    fine: 'штраф',
    serviceTime: 'сервисное КП, мин время',
    maxTime: 'макс время',
    selectClass: 'Выберите класс...',
    classIsEmpty: 'Отсутствую классы!',
    pos: 'Поз. Ном.',
    startFinish: 'Время старта/финиша/гонки',
    errorConnection: 'Потеряно соединение с сервером',
    recoveryConnection: 'Соединение с сервером восстановлено',
    notConnection: 'Нет связи с сервером, попробуйте через 5 минут',
    uidIsCopying: 'UID гонки cкопирован в буфер обмена',
    linkIsCopying: 'Скопирована ссылка на эту таблицу в буфер обмена.',
    lap: 'Круг',
    autosport_info: 'Своей подписью я подтверждаю, что вся информация, содержащаяся в Заявочной форме верна. Я принимаю все условия оплаты и условия моего участия в данном мероприятии. Кроме того, своей подписью подтверждаю, что ознакомился с регламентом соревнований и полностью с ним согласен. Обязуюсь выполнять все требования регламента и техники безопасности. Принимаю на себя все риски и всю отвественность за возможные последствия своего участия, в том чилсе за возможные столкновения с другими авто либо повреждение своего авто. Даю согласие на обработку персональных данных. Признаю за организатором право на использование всех фото- видеоматериалов соревнований для пропаганды автомобильного спорта. Полностью беру на себя отвественность за жизнь и ЗДОРОВЬЕ ЛИЦ, находящихся в автомобиле во время соревнований.',
    accessdenied: 'Нет доступа',
    time_state: 'Показывать время',
    edit_mode: 'Режим редактирования',
    show: 'Показать',
    hide: 'Скрыть',
    display: 'Отображение',
    minutes_short: 'мин',
    start_time: 'Cтарт',
    finish_time: 'Финиш',
    laps_amount: 'Кол-во кругов',
    lap_best_time: 'Лучшее время круга',
    penalization_time: 'Пенализация',
    behind_the_leader: 'Отставание от лидера',
    who_created: 'Кто создал',
    who_edited: 'Кто редактировал',
    who_deleted_when: 'Кто, когда удалил',
    no_filter: 'Без фильтра',
    not_payed_competitors: 'Не оплатившие',
    no_docs: 'Нет документов',
    not_processed_competitors: 'Не обработанные',
    with_errors_in_docs: 'С ошибками в документах',
    under_18: 'Младше 18 на дату гонки',
    under_16: 'Младше 16 на дату гонки',
    blank: 'Пусто',
    registration: 'Регистрация',
    overall_standings: 'Абсолютный зачет',
    close_registration: 'Закрыть регистрацию',
    open_registration: 'Открыть регистрацию',
    form_application: 'Сформировать заявки',
    form_tech_cards: 'Сформировать техкарты',
    form_tech_card: 'Техкарта',
    select_application_form: 'Выберите форму заявки',
    select_action: 'Выберите действие',
    application_form_full: 'Заявка полная',
    stimulsoft_loading: ' (Загрузка отчета...)',
    application_form_short: 'Заявка краткая',
    protocols: 'Протоколы',
    registration_list_short: 'Список краткий',
    registration_list_full: 'Список полный',
    registration_list_full_csv: 'Список полный выгрузить',
    technical_protocol: 'Техкомиссия',
    medical_protocol: 'Медкомиссия',
    approved_protocol: 'Допущенные',
    result_protocols: 'Итоговые протоколы',
    individual_standings: 'Личный зачет',
    individual_summary_standings: 'Сводный протокол личного зачета',
    team_standings: 'Командный зачет',
    issued_trackers: 'Выданные трекеры',
    issued_tags: 'Выданные датчики',
    tags_return: 'Возврат датчиков',
    service_functions: 'Сервисные функции',
    add_image: 'Добавить изображение',
    select_image: 'Выберите изображение',
    left_logo: 'Логотип слева',
    center_logo: 'Логотип по центру',
    right_logo: 'Логотип справа',
    send_sms_title: 'Отправить СМС участникам, которые выведены в таблице ниже',
    sms_text: 'Текст СМС',
    sms_hint: 'Услуга платная, $1 р/смс, макс $2 символов',
    send: 'Отправить',
    sms_symbols_count: 'Количество символов: $1 / смс: $2',
    sms_max_symbols: ' (достигнуто максимальное количество символов)',
    team_dnf: 'Не финишировали',
    team_finish: 'Финишировали',
    female_short: 'Ж',
    male_short: 'М',
    loading_to_server: 'Изображение "$1" загружается на сервер...',
    image_added_to_selection: 'Изображение "$1" добавлено в варианты выбора для логотипов',
    sms_confirm_header: 'Подтверждение отправки',
    sms_sent: 'СМС успешно отправлены!',
    sms_not_sent: 'Не удалось отправить СМС: $1',
    sms_forbidden: 'только владелец или главный организатор могут отправлять смс',
    sms_canceled: 'Отправка отменена',
    error_err: 'Ошибка: $1',
    unknown_error: 'Неизвестная ошибка',
    competitor_info: 'Добавить инф о участнике',
    load_earlier_races: 'Загрузить более ранние гонки',
    load_later_races: 'Загрузить более поздние гонки',
  },
  us: {
    all_track: 'All track',
    sendToEmail: 'Send email code',
    attachments_new_user_hint: "After saving your profile, you can access it again and attach images, documents, and links that will be visible to viewers and organizers. Additionally, when registering for a competition, it will be easier for you to upload the required documents requested by the organizers",
    header_all: 'All',
    register_menu: 'Register',
    close: 'close',
    competitor_info_dialog: 'Competitor info',
    lapInvalid: 'Lap failed',
    lapValid: 'Lap is Ok',
    bestLap: 'Best lap',
    joker: 'Joker',
    optionalLap: 'Optional CP',
    editedLap: 'Edited CP',
    timebar: 'timebar',
    custom_map_on_off: 'On/Off your map',
    save_success: 'Save success',
    custom_map: 'Add your map',
    connect: 'Connection restored',
    wrongdate: 'Invalid date. Date format: YYYY-MM-DD hh:mm:ss',
    disconnect: 'Connection to server lost',
    distance: 'Distance traveled',
    diff_speed: 'Average speed',
    max_speed: 'Maximum speed',
    show_track: 'Show track',
    hide_track: 'Hide track',
    no_start_man: 'Didn`t start',
    no_start_woman: 'Didn`t start',
    no_tracker: 'No tracker',
    waiting_param: 'Waiting for Parameters',
    loading: 'Loading...',
    select_class: 'Select a Class',
    laps: 'Laps',
    time: 'Time',
    empty_list: 'List is empty',
    position: 'Position',
    start: 'Start',
    finish: 'Finish',
    common_time: 'Common time',
    track_length: 'Track length',
    speed_limit: 'Speed limit',
    min: 'min',
    all: 'All',
    track_resume_online: 'Live broadcast',
    track_resume_history: 'View record',
    track_start_real: 'Real start time',
    track_start_massive: 'From one time start',
    show_details: 'Show details',
    hide_details: 'Hide details',
    imePoint: 'CP',
    timePrevPoint: 'from the previous CP',
    timeStartPoint: 'from the lap start',
    timeStartUser: "from the competitor's start",
    timeDeltaLeader: 'lag behind the leader',
    not_selected: 'Not selected',
    search_placeholder: `Please enter competitor's number to search`,
    saved: 'Saved',
    restore_mark_question: 'Restore mark?',
    delete_mark_question: 'Delete mark?',
    penalty_and_dnf: 'DNF and penalty',
    penalty: 'Penalty',
    comment: 'Comment',
    dnf: 'DNF',
    descent_0: 'Not selected',
    descent_1: 'No descent',
    descent_2: 'Disqualification',
    descent_3: 'Time is up',
    descent_4: 'Breaking',
    descent_5: 'Injury',
    descent_6: "Didn't finish",
    dnf_reason: 'DNF reason',
    ok: 'Save',
    marshal_num: 'Marshal number',
    dateTimeMark: 'Date, time mark',
    time_from_previous_mark: 'Time from previous mark',
    created: 'Created',
    edited: 'Edited',
    deleted: 'Deleted',
    date: 'Date',
    change: 'Change',
    datauser: 'Participant data №',
    speed: 'Speed',
    distance_value: 'km',
    speed_value: 'km/h',
    mark_date: 'Tracker date',
    mark_time: 'Tracker time',
    age: 'years',
    month: 'month',
    racetime: 'Race time',
    lastpoint: 'Last mark',
    gpstracker: 'GPS tracker',
    callInfo: `*It is completely FREE of charge, your call will be rejected, it is normally. You have 5 minutes to make a call, after you will need to make a new verification request.`,
    close_race_confirm: 'Close the competition? After this, editing results will become impossible, results will be recorded in the participants hall of fame, and they will be sent an SMS requesting to rate the competition',
    sms_confirm_query: 'An SMS will be sent to $1 participants, your text contains $2 characters, each SMS can contain $3, i.e. each participant will receive $4 SMS, sending cost $5 x $6 x $7 = $8 rubles, send? Sending will take $9 seconds',
    'finish/mark': 'Finish/',
    application_text: `I, the undersigned, accept the requirements of the Regulations, Rules, Sports Code of the Russian Motorcycle Federation (hereinafter referred to as the RMF), the Competition Rules, other RMF regulatory documents, and Russian legislation, and undertake to strictly adhere to them. I confirm that I have no medical contraindications to participating in sports, do not take drugs, and do not abuse alcohol. In the event of injury or illness, I authorize medical personnel to provide the necessary medical assistance and report the relevant information to the competent authorities and interested parties. I confirm that the information I provided in my application is accurate. The motorcycles I entered meet the technical requirements. I hereby confirm that I have a negative polymerase chain reaction test for COVID-19, obtained no earlier than three calendar days prior to the start of the event. I consent to the processing of my personal data in accordance with Federal Law 152-FZ.`,
    notfound: 'No Competitions found for the specified period. Select other dates on the calendar.',
    areyousure: 'Are you sure that you want to delete this competition class?',
    youisnotmember: 'You are not a paticipant in this competition, only participants could write a review',
    class_numbers_about_title: 'Leave the fields blank if any numbers are allowed',
    class_numbers_by_org_about: 'Here you can set the rules for assigning numbers to participants. If you check "Numbers are assigned by the organizer", then the participants will not be able to independently select numbers when registering online through the site, but the organizer will still be able to assign numbers to them in the program on their smartphone. <br> Setting the range affects both online registration on the site and the operation of the program on a smartphone - participants and organizers will be able to choose a number only from the range specified for this class',
    class_marshals_points_about: 'Click on the wrench button to select the marshal marks in the dialog box, if you want to edit the mark line manually, click on the pencil icon (you must know and carefully observe the line format in this case)',
    class_finish_all_about: 'The mark "Finish all after the leader" means that after the finish of the leader, all other participants must finish by completing their next lap, regardless of other conditions',
    class_control_time_about: 'Check the box if you want to count the race time until the finish close from the start of the first competitor in the class; leave unchecked if you want to calculate the time limit for each competitor from his start',
    class_control_time: 'To count the control time of the competition from the start of the first participant in this class',
    class_finish_minutes_about: 'Finish closing time in minutes from the start of the first participant in the class (or for each participant - depending on the position of the switch below) - at the end of this time, the program will warn that the finish time is closed, but marks will be recorded, but will not be taken into account in the final result',
    class_marshal_about: 'Used when the marshal marks a contestant (at the end of a circle or in the course) to prevent duplicate marks.',
    class_finish_conditions_about: 'The time of the сompetition is indicated, the laps are not filled - the race goes on for the specified time, the winner is the one who completes more laps in the minimum time, but not less than the specified one. Competitors will finish after the leader completes the lap AFTER the set time. <br>Laps are indicated, the time is empty - the competition lasts a given number of laps and the winner is the one who completes this number of laps in the minimum time. <br>The time of the competition and the laps are indicated - the participants race the specified time, when the leader passes the first lap after the end of the specified time, then the participants must still race the specified number of laps',
    class_allowable_age_about: 'Leave fields blank if any age is allowed, or fill in only one field to check older/younger respectively',
    areyousure_delete_mashal: 'Are you sure that you want to delete this mashal?',
    multistage_annotation: 'If enabled, the program will allow the generation of final results for multiple stages, such as Prologue, Day 1 of the race, Day 2 of the race, or first heat, second heat',
    info_field_annotation: 'This field name will be shown to competitors in online registration and results with additional information about registration - e.g. vehicle model, which competitor is riding',
    totalsCountBy: 'Calc totals by the time sum (if not checked - by score table)',
    applicationText: 'Text to be printed in the bottom of application form for competitor',
    partialLapCountMethod: 'Calc last partial lap in result up to last passed marshal',
    showOnlyConfirmed: 'Show in list of registered on web site only competitors with confirmed registration and payment',
    stimulsoft_loading: ' (Stimulsoft is loading...)',
    autosport_info: "By signing, I confirm that all information contained in the Entry Form is accurate. I accept all payment terms and the conditions of my participation in this event. Furthermore, by signing, I confirm that I have read and fully agree with the competition regulations. I undertake to comply with all regulations and safety requirements. I assume all risks and responsibility for any possible consequences of my participation, including any collisions with other vehicles or damage to my vehicle. I consent to the processing of my personal data. I acknowledge the organizer's right to use all photo and video materials from the competition to promote motorsports. I assume full responsibility for the lives and health of all persons in the vehicle during the competition.",
    needVerifiedEmail: 'You need to confirm your email and enter the PIN code sent to it',
    emailInfoInit: 'You will receive a code by email that you will need to enter',
    email_input: 'Email',
    error_max_competitors_in_class: 'The maximum number of competitors has already registered for this class - $1 out of $2 allowed',
    error_max_competitors_in_race: 'The maximum number of competitors has already registered for the competition - $1 out of $2 allowed',
    error_answer_obligatory: 'The answer to this question is obligatory',
    no_server_connection: 'No connection to the server, please try refreshing the page',
    deleted_from_org: 'User deleted from org team',
    delete_from_org: 'Delete seleted user from org team?',
    delete_from_org_self: 'Are you sure you want to delete yourself from org team? You would not be able to edit this competition then',
    select_org_role: 'Select org role',
    select: 'Select',
    owner: 'Owner',
    main_org: 'Main org',
    judge: 'Judge',
    marshal: 'Marshal',
    role: 'Role',
    is_org: 'Organizer rights',
    admin: 'Admin rights',
    beta_tester: 'Beta-tester',
    required_field: ' - obligatory',
    required_field_annotation: '* - obligatory fieldя',
    profileTypeAbout: 'When your profile is public, spectators will be able to see your gallery photos, the information you write about yourself, and your age',
    required_file: 'required field',
    saving: 'Saving...',
    valid: 'Valid',
    examination: 'Under review',
    add: 'Add',
    image: 'Image',
    select_my_files: 'Select a file from your profile',
    select_user_files: 'File from profile',
    new_user_file: 'New file',
    user_form_data_error: 'Error saving profile',
    add_org: 'Add to org team',
    add_reg: 'Add to class',
    add_to_crew: 'Add to crew',
    delete_from_crew: 'Delete from crew',
    empty_class: 'No confirmed competitors',
    invalidFileSizeMessageSummary: '{0}: Invalid file size',
    invalidFileTypeMessageDetail: 'allowed file types: {0}',
    invalidFileLimitMessageSummary: 'Maximum number of files exceeded',
    invalidFileLimitMessageDetail: 'limit is {0} at most',
    invalidFileTypeMessageSummary: '{0}: Invalid file type',
    invalidFileSizeMessageDetail: 'Maximum upload size is {0}',
    competitors: 'Competitors',
    profile_edit: 'Change',
    profile_cancel: 'Cancel',
    req_gender: 'Wrong gender for this class',
    phone_crew_format: 'Phone number entry format',
    error_age: 'Wrong age for this class',
    error_reg_info: ' - Provide registration information',
    error_document: ' - Add file',
    error_number: ' - Please indicate the tail number',
    error_password_short: ' - Too short password',
    error_info_large: ' - Too much extra information',
    error_fio_empty: ' - Enter your full name',
    error_phone_empty: ' - Please enter your phone number',
    error_fio: ' - Full name must begin with capital letters ',
    error_city: ' - Specify City',
    error_birthday: ' - Please fill your birth date',
    error_birthday_date: ' - Wrong birth date',
    error_password_missmatch: ' - The passwords you entered do not match',
    error_password: ' - You password is very short. Please change you password',
    error_insurance: ' - Your insurance is expired',
    error_citizenship: ' - Please indicate your citizenship',
    error_email: ' - Your email is not in the correct format',
    crew_competitors_need_reg: '*Register to activate the field',
    crew_competitors_title: 'Crew members',
    orgs_title: 'Org team',
    number: 'Number',
    reg_saved: 'You are registered to competition',
    reg_changed: 'Registration data has been changed',
    reg_class_changed: 'Registration class has been changed',
    reg_need_confirm: 'Your application for registration has been accepted, you will appear in the list of registered people after payment and verification of documents by the organizer',
    are_sure: 'Are you sure to change class?',
    confirm: 'Confirm',
    reg_data_is_deleted: 'Deleted',
    information: 'Information',
    change_reg: 'Change registration',
    change_reg_crew: 'Change registration and crew',
    del_reg: 'Delete registration',
    number_is_wrong: 'number is wrong',
    number_is_busy: 'number is already taken',
    info_field_race: 'Registration information',
    loading_race: 'Loading race',
    register: 'Registration form',
    no_places: 'There is no free slots to register to this class',
    helper_crew_class: 'Crew of %1% members can register to this class',
    helper_crew_class_members_range: 'Crew of %1% to %2% members can register to this class',
    helper_numbers_range: 'Numbers range %1% - %2%',
    s_permitted_min_age: 'Minimum age to register to this class: %1%',
    s_permitted_max_age: 'Maximum age to register to this class: %1%',
    s_permitted_age_range: 'Permitted age range to register to this class: %1% - %2%',
    s_any_gender: 'Any gender can register to this class',
    s_only_male: 'Only males can register to this class',
    s_only_female: 'Only females can register to this class',
    s_any_age_permitted: 'Any age permitted to register to this class',
    s_finish_after_leader: 'Finish all after leader',
    s_fin_close_time_description: 'Finish closes after %1% from this class first competitor start time',
    s_fin_close_time_description_every: 'Finish closes after %1% from this class every competitor start time',
    s_checkpoints_description: 'The track contains these checkpoints: %1%',
    add_new_competitor: 'There is no competitor with this phone number. Register new сompetitor?',
    add_new_competitor_complete: 'Member added to the crew',
    add_new_org_complete: 'User added to the org crew',
    add_new_org_error: 'Save the race first',
    save_race_before_add_class: 'Save the race first to add classes',
    save_race_before_add_marshal: 'Save the race first to add marshals',
    new_competitor_dialog_title: 'Adding new сompetitor',
    deleted_from_crew: 'Competitor deleted from crew',
    crew_is_full: 'Crew is full',
    warning: 'Warning',
    hint_crew: '* Enter phone number and press Add to add crew member. If there is no such competitor at server, you can create one.',
    hint_add_reg: '* Enter phone number and press Add to register competitor. If there is no such competitor at server, you can create one.',
    hint_add_org: '* Enter phone number and press Add to register organizer. If there is no such user at server, you can create one.',
    s_minLapTime: 'Min lap time %1% sec',
    race_time: 'Race duration',
    s_lap_one: '%1% lap',
    s_laps_few: '%1% laps',
    s_laps_many: '%1% laps',
    s_laps_other: '%1% laps',
    s_numbers_choosen_by_competitors: 'Competitors can choose numbers by themselves',
    s_numbers_assigned_org: 'Numbers assigned by org',
    s_numbers_min_max: 'Allowed numbers from the range %1% - %2%',
    s_numbers_assing_by_org: 'Numbers are assigned by the orgs',
    busy_numbers: 'Busy numbers',
    bike: 'Device',
    no_competitors: 'There is no one in this race class',
    reg_in_class: 'Register for this class',
    required_ruid: 'Specify the race UID',
    sport_title: 'Sport titles',
    team: 'Team',
    insuranceNo: 'Number of insurance',
    insurance: 'Date of insurance',
    dob: 'Birth date',
    city: 'City',
    internationalName: 'International name transcription',
    name: 'Name and last name',
    motto: 'Motto',
    citizenship: 'Сitizenship',
    profileDataConfirmed: 'Profile is confirmed',
    profileOpened: 'Profile is opened - spectators will be able to see your gallery photos (except privates ones), the information you write about yourself, and your age',
    profileClosed: 'Profile is closed - spectators will not see your gallery photos, the information you write about yourself, and your age',
    editorAvatar: 'Avatar Editor',
    profileType: 'is Profile opened?',
    emaileConfirmed: 'Email confirmed',
    phoneConfirmed: 'Phone confirmed',
    checkPhone: 'Phone number verification required',
    checkEmail: 'Email verification required -  a message has been sent to the specified email address. Please check it and click on the link provided in the message',
    emailSended: 'Email sent',
    emailNotSended: 'Email not sent',
    phone_is_busy: 'This phone number is registered to another user. If is is your phone number, do not create new profile, login with this number. You can use Send password button at the login, if you do not remember it. In case of difficulties, please write to the developers at reg@marshalone.com',
    exitConfirm: 'Log out?',
    wrongFormat: 'Wrong phone.',
    password: 'Password',
    passwordRe: 'Retype password',
    undefGender: 'Undefined',
    manGender: 'Man',
    womanGender: 'Woman',
    myFoto: 'My photo',
    errorFile: 'Error loading file',
    unsupportedFileType: 'Unsupported file type',
    inputIsEmpty: 'Input is empty',
    error: 'Error',
    addLink: 'Add',
    inputLink: 'Provide a link',
    myLinks: 'Links',
    myImages: 'Images',
    myDocuments: 'Documents',
    all_race: 'All races',
    org: 'Manage',
    comp: 'Participate',
    competitor: 'Competitor',
    organisator: 'Organizer',
    phone: 'Phone',
    email: 'Email',
    dateOfBirdth: 'Date of Birth',
    gender: 'Gender',
    aboutOfMe: 'About myself',
    auth: 'Login',
    exit: 'Logout',
    profile: 'Profile',
    save: 'Save',
    unsaved: 'Not saved',
    cancel: 'Cancel',
    back: 'Back',
    list: 'Races list',
    doorg: 'Become an organizer',
    images: 'Images',
    documents: 'Documents',
    links: 'Links',
    notFound: 'No races found for the specified period. Select other dates on the calendar.',
    private: 'Private',
    regisclosed: 'Registration is closed',
    langs: 'Select translation',
    yes: 'Yes',
    no: 'No',
    result: 'Results',
    map: 'Map',
    main: 'MarshalOne',
    dates_filter: 'Date period',
    types_filter: 'by type',
    void: 'void',
    success: 'Success',
    emailIsSucces: 'Your email is successfully verified!',
    profileTypeOn: 'Open profile',
    profileTypeOff: 'Close profile',
    getPassword: 'Send password',
    confirmCallNumber: 'Confirm by outgoing call',
    confirmCallInit: 'Confirm by incoming call',
    confirmPincode: 'Confirm by code from SMS',
    getCallNumber: 'Login by outgoing call',
    getCallInit: 'Login by incoming call',
    getPincodeEmail: 'Login by code from Email',
    getPincode: 'Login by code from SMS',
    enter: 'Login by password',
    noauth: 'Call required',
    pincode: 'Pincode',
    wrongPhone: 'Wrong phone',
    wrongPassword: 'Wrong auth data',
    info: 'Information',
    call: 'To verify your phone number please call to $1 to $2',
    user_created: 'User is created, confirm by call number is required',
    next: 'Next',
callInfoInit: 'You will receive a call, you need to enter the last 4 digits of the incoming number in the PIN field.',
    errorCallInit: 'Server error after call',
    callCheckInfo: 'To log in, call from your phone to $1. The call is free (including from abroad), after the call you will be logged in automatically. You have $2 minutes for the call.',
    callCheckStatus: 'Check call status',
    callCheckInfoHint: 'Press the "Login by outgoing call" button and call from your phone to the specified number - your phone will be verified automatically. The call is free, even from abroad. After the call you will be logged in automatically.',
    waitEmail: 'You will receive a PIN code by email, which you will need to enter in the "PIN code" field.',
    waitCall: 'Please wait for a call, you should not answer it, just put 4 last digits of the incoming number into the PIN field',
    waitSmsPass: 'The password has been sent to your phone number via SMS. Please wait for the message.',
    passwordInfoInit: 'In case you forgot your password, you can recieve it on your phone or email',
    user_form_fill_error: 'Fill all obligatory fields!',
    user_form_fill_error_city: 'Incorrect city entered - please type the name of the city in the text field and then select from the suggested list!',
    delete_attachment: 'Delete attachment',
    delete_images: 'Delete image',
    delete_files: 'Delete document',
    delete_links: 'Delete link',
    attachment_params: 'Attachment parameters',
    description_hint: 'Description',
    valid_until: 'Valid until',
    other: 'Other',
    error_date: 'Wrong date',
    private_label: 'Private',
    private_helper: 'If the switch is enabled, only you or the competition organizer will be able to see this file; spectators will not be able to see it',
    attachment_doc_type_helper: 'If you select the document type and specify its validity period, this document will be automatically attached when registering for the competition, provided that this document type is required for registration',
    doc_type_label: 'Document type',
    register_yourrself_first_hint: 'Register youself first and then add crew members',
    add_crew_members_now: 'Now you can add crew members',
    female: 'Female',
    male: 'Male',
    competitor_hof_dialog: 'Last races',
    map_off: 'List',
    map_on: 'On map',
    max_competitors: 'Max competitors in race',
    helper_max_competitors_reason: 'If a value greater than zero is specified, it sets the maximum number of competitors who can register for the competition through the website. This value does not affect the addition of competitors by the organizer — more can be added than indicated. Crew members are not counted in the calculation',
    max_competitors_class: 'Max competitors in class',
    helper_max_competitors_class_reason: 'If a value greater than zero is specified, it sets the maximum number of competitors who can register for this class through the website. This value does not affect the addition of competitors by the organizer — more can be added than indicated. Crew members are not counted in the calculation',
    question: 'Question',
    poll_section: 'Competitor questionnaire',
    poll_annotation: 'The questions you enter here will be shown to the competitor at the time of registration. When a question is marked as Obligatory, the competitor will not be able to register until they provide an answer. These questions can be used to gather additional information about the participants for the commentator, for example, What are your expectations for the race? or to obtain information for the organizer, for example, Do you need fuel with oil or without at the refueling station?',
    s_dont_count_first_lap_as_best: 'Do not consider the first lap as the best (If marked, the first lap will not be included in the calculation of the best lap, for example, if it is longer or shorter due to the starting position)',
    location_description: 'Description of how to get to the starting point or camp',
    open_admin_console: 'Open admin console',
    location_annotation: 'Drag marker or click at start/camp location',
    orgs_list: 'Orgs team',
    race_copy_name: '(Copy)',
    copy_race: 'Copy',
    copy_race_no_docs_no_competitors: 'Copy without competitors',
    copy_race_no_docs_competitors: 'Copy with competitors, without documents and payment',
    copy_race_docs_competitors: 'Copy with competitors, documents, and payment',
    copy_race_confirm: 'Create the selected competition copy?',
    delete_race: 'Are you sure you want to delete the selected race? All results, registrations, and teams will be deleted!',
    delete_race_confirm: 'Are you still sure you want to delete the race? Click No if you really wish to delete it.',
    create_new: 'Create',
    create_new_race: 'Create new competition?',
    docType: 'Doc type',
    used: 'Required',
    obligatory_at_reg: 'Obligatory',
    wrong_finish_conditions: 'At least one of Race time or Laps should be filled',
    wrong_members_range: 'Wrong values of crew members quantity',
    wrong_numbers_range: 'Wrong numbers range',
    wrong_age_range: 'Wrong age range',
    sort_position: 'Position in list',
    form_fill_error: 'Fill all obligatory fields!',
    form_fill_error_city: 'Incorrect city entered - please type the name of the city in the text field and then select from the suggested list!',
    obligatory_param: 'obligatory parameter',
    wrong_date: 'wrong date',
    user_payed: 'Payment accepted',
    doc_not_accepted: 'not accepted',
    docs_valid: 'Your registration is confirmed',
    yourated: 'You already have rated this competition',
    rateisadded: 'Your rating has been added',
    rateCategory0: 'Race track',
    rateCategory1: 'Festive atmosphere',
    rateCategory2: 'Comfort for competitors',
    rateCategory3: 'Sports officiating',
    tableEmpty: 'No records found',
    rate: 'Rate',
    rateComments: 'Comments from race participants',
    rateComment: 'Add your comment to your rating',
    competitors_list: 'List of all participants is registration order',
    new_class: 'Adding a new class',
    class_numbers_max: 'By number',
    class_numbers_min: 'From number',
    class_numbers_rules: 'Numbers assignment rules',
    class_numbers_about: 'Number range for this class',
    class_numbers_by_org: 'Numbers assigned by the organizer',
    class_marshals_points: 'Marshals through which the track passes',
    class_finish_all: 'Finish all after the leader',
    class_finish_minutes: 'Finish closing time in minutes',
    class_min_lap_second: 'Minimum lap time',
    class_lap_count: 'Laps',
    class_all_minutes: 'Competition time in minutes',
    class_finish_conditions: 'Finish conditions',
    class_crews_max_count: 'Max in the crew',
    class_crews_min_count: 'Min in the crew',
    class_crew_active: 'Crews participating',
    class_age_max: 'Max age',
    class_age_min: 'Min age',
    class_allowable_age: 'Allowable age',
    class_required_competitor: 'Membership Requirements',
    class_gender: 'Allowed gender',
    class_about: 'Description: contribution, document required, etc.',
    class_name: 'Class name',
    notsaved: 'Not saved',
    addClass: 'Add class',
    classes: 'Classes',
    metadata: 'Additional files',
    block: 'Required to save the competition before uploading files',
    race_deleted: 'Competition deleted',
    race_copied: 'Competition copied',
    delete: 'Delete',
    edit: 'Edit',
    logo: 'Competition / organizer logo',
    main_foto: 'The picture of the competition (poster)',
    about: 'Description of the competition for spectators and participants',
    useNfc: 'NFC',
    useRfid: 'RFID',
    useGps: 'GPS trekers',
    useChronoTags: 'Сhrono tags',
    tech_section: 'Technologies used to mark competitors in this competition',
    hasTeamStandings: 'There is a team score',
    rules_section: 'Scoring Rules',
    multistage: 'Multistage',
    registration_rules_section: 'Registration rules',
    allow_equal_numbers: 'Allow equal numbers in different classes',
    has_absolute_standing: 'Has overall standing',
    s_by_best_lap_rule: ' Calc results by best lap',
    show_mills_results: 'Show milliseconds in results',
    s_location: 'Start or base camp location',
    coordinates: 'GPS: ',
    infoFieldName: 'Registration field name',
    type_sport: 'Kind of sport',
    time_zone: 'Time zone',
    title: 'Title',
    race_changes: 'Change',
    not_found: 'No Competitions found for the specified period. Select other dates on the calendar.',
    list_registered_user: 'List of participants',
    change_register: 'Change reg info',
    create_race: 'Create competition',
    current_day: 'Today',
    class_deleted: 'Race class has been sucessfully deleted',
    marshals: 'Marshals',
    add_marshal: 'Add marshal',
    mashal_data: 'Marshal data',
    points: 'Points',
    radius: 'Punching radius',
    marshal_deleted: 'Marshal deleted',
    no_data: 'No data',
    download_questions_csv: 'Download poll CSV',
    application_form_autosport: 'Autosport appl',
    upload_results_from_file: 'Upload results from file',
    tags_panel: 'GPS trackers, tags',
    not_confirmed: 'Not confirmed registration',
    org_comment: 'Org comment',
    form_mfr_licenses: 'Form russian moto licenses',
    participation_in_races_csv: 'Participation in races',
    sport_subtype: 'Sport discipline official name',
    mfr_license_c: 'Russian moto license C-type',
    report_trackers: 'Issued GPS trackers',
    report_tags: 'Issued chrono tags',
    report_competitors_list_full: 'Registrations list',
    report_overall_results: 'OVERALL PERSONAL RESULTS PROTOCOL',
    report_personal_results: 'PERSONAL RESULTS PROTOCOL',
    report_tech_committee: 'TECHNICAL COMMITTEE PROTOCOL',
    report_medical_committee: 'MEDICAL COMMITTEE PROTOCOL',
    report_admitted: 'PROTOCOL OF ADMITTED COMPETITORS',
    report_bib: 'Bib',
    report_position: 'Pos',
    report_competitor_name: 'Competitor name, surname',
    report_competitor_birth_date: 'Competitor birth date',
    report_phone: 'Phone',
    report_email: 'Email',
    report_starting_fee: 'Payment',
    report_reg_confirmed: 'Reg confirmed',
    report_reg_time: 'Reg time',
    report_class: 'Class',
    report_sport_title: 'Sport titles',
    report_insurance_no_summ: 'Insurance no, summ',
    report_sport_license: 'Sport license no',
    report_competitor_signature: 'Signature certifying knowledge of the competition rules and the sports code',
    report_tech_confirm: 'Tech check time',
    report_blood_pessure: 'Blood pressure',
    report_name_team_city: 'Competitor name, team, city',
    report_team_city: 'Team, city',
    report_team: 'Team',
    report_city: 'City',
    report_time_start: 'Start time',
    report_time_fin: 'Finish time',
    report_time_race: 'Race time',
    report_laps: 'Validated number of laps',
    report_run: 'run',
    report_run_position: 'pos',
    report_run_points: 'points',
    report_run_time: 'time',
    report_best_lap_time: 'Best lap time',
    report_total_time: 'Total time',
    report_total_points: 'Total points',
    report_tracker: 'GPS tracker',
    report_tag: 'Chrono tag',
    report_device_returned: 'Returned at',
    report_total_devices: 'Total devices issued',
    report_main_org: 'Race director name, signature',
    report_main_judge: 'Main judge',
    report_secretary: 'Main secretary',
    report_main_tech: 'Chairman of the Technical Committee',
    report_main_medic: 'Main medical',
    report_rules: 'The winner is determined by the highest total points with a maximum of $1 point per race; in case of a tie in points - by best positions quantity, in case of tie -$2',
    report_rules_by_best_lap: 'The winner is determined by the best lap from all races',
    report_rules_by_time: 'The winner is determined by the lowest total time with equal distance covered',
    add_competitor: 'Add competitor',
    del_time: 'Delete',
    deleted_reg: 'Deleted',
    statistic: 'Statistics',
    unsuccess_registrations: 'Unsuccessful registrations',
    change_registration: 'Change registration',
    delete_number_confirm: 'Delete this competitor start number?',
    delete_tag_confirm: 'Delete this competitor chrono tag?',
    assign_numbers: 'Assign numbers by reg time',
    assign_numbers_within_class: 'within every class',
    assign_numbers_across_all: 'across all classes',
    numbers_assigned: 'The numbers has been assigned',
    numbers_deleted: 'The numbers has been deleted',
    delete_numbers: 'Delete numbers',
    delete_numbers_confirm: 'Delete numbers for the competitors in selected class?',
    totals: 'Totals',
    competitors_totals: 'Competitors: ',
    birthdate: 'Birthdate',
    reg_info: 'Reg info',
    reg_time: 'Reg time',
    start_fee: 'Fee',
    docs: 'Doc',
    gps_tracker: 'Tracker',
    chrono_tag: 'Tag',
    race_state_0: 'Registration opened',
    race_state_1: 'Registration closed',
    race_state_2: 'Competition started',
    race_state_3: 'Competition closed',
    race_state: 'Competition state',
    data_to_clipboard: 'Data copied to clipboard',
    confirm_delete_competitor: 'Delete $1 registration? This action cannot be undu!',
    delete_competitor: 'Delete competitor',
    doc_check_header: 'Documents check',
    no_document: 'No documents uploaded',
    reason: 'Reason',
    allDocumentsValid: 'Registration confirmed',
    save_error: 'Error save',
    change_start_fee: 'Fee',
    notFoundCompetitorByNumber: 'No competitor found for the specified number',
    loadingDataReport: 'Generating a report...',
    nopenalty: 'There are no penalties in this circle',
    newVersion: 'New kind of results',
    oldVersion: 'Results in table',
    DOCUMENTS: 'Documents',
    PROGRESS: 'Progress',
    PROGRESSV2: 'Results',
    lap: 'Lap',
    linkIsCopying: 'Copied the link to this table to the clipboard.',
    uidIsCopying: 'Race UID copied to clipboard',
    notConnection: 'No connection to the server, please try in 5 minutes',
    recoveryConnection: 'Server connection restored',
    errorConnection: 'Lost connection to server',
    startFinish: 'Start/ finish/ race time',
    pos: 'Pos. Bib',
    race: 'Race',
    class: 'Class',
    classCopy: 'Copy Race UID',
    classCopyLink: 'Copy link to online results',
    progress: 'Online results',
    document: 'Documents',
    timePoint: 'CP',
    timeDeltaLider: 'lag behind the leader',
    FIO: 'Competitor',
    exportCSV: 'Export as csv',
    infoErrors: 'Lap penalty information',
    FIO1: 'сompetitor',
    editLap: 'Editing a lap',
    lapParams: 'Class parameters',
    finishAfterLeader: 'Finish everyone after the leader',
    finishing: 'finish',
    lapsComment: 'Lap marks',
    jokerInfo: '(penalty - no lap credit)',
    lapFinished: 'lap mark / finish',
    fine: 'fine',
    serviceTime: 'service checkpoint, min time',
    maxTime: 'max time',
    selectClass: 'Please select a class...',
    classIsEmpty: 'Classes are empty!',
    accessdenied: 'Access denied',
    time_state: 'Times type',
    edit_mode: 'Edit mode',
    show: 'Show',
    hide: 'Hide',
    display: 'Display',
    minutes_short: 'min',
    start_time: 'Start',
    finish_time: 'Finish',
    laps_amount: 'Laps amount',
    lap_best_time: 'The best lap time',
    penalization_time: 'Penalization',
    behind_the_leader: 'Behind the leader',
    who_created: 'Who created',
    who_edited: 'Who edited',
    who_deleted_when: 'Who deleted, when',
    no_filter: 'No filter',
    not_payed_competitors: 'Not payed',
    no_docs: 'No documents',
    not_processed_competitors: 'Not processed',
    with_errors_in_docs: 'With errors in docs',
    under_18: 'Under 18 on the date of the race',
    under_16: 'Under 16 on the date of the race',
    blank: 'Blank',
    overall_standings: 'Overall standings',
    registration: 'Registration',
    close_registration: 'Close registration',
    open_registration: 'Open registration',
    form_application: 'Form applications',
    form_tech_cards: 'Create technical cards',
    form_tech_card: 'Technical card',
    select_application_form: 'Select application form',
    select_action: 'Select action',
    application_form_full: 'Application full',
    application_form_short: 'Application short',
    protocols: 'Protocols',
    registration_list_short: 'Short list',
    registration_list_full: 'Full list',
    registration_list_full_csv: 'Full list download',
    technical_protocol: 'Technical committee',
    medical_protocol: 'Medical committee',
    approved_protocol: 'Approved',
    result_protocols: 'Final protocols',
    individual_standings: 'Individual standings',
    individual_summary_standings: 'Overall individual standings',
    team_standings: 'Team standings',
    issued_trackers: 'Issued trackers',
    issued_tags: 'Issued sensors',
    tags_return: 'Return of sensors',
    service_functions: 'Service functions',
    add_image: 'Add image',
    select_image: 'Select image',
    left_logo: 'Left logo',
    center_logo: 'Center logo',
    right_logo: 'Right logo',
    send_sms_title: 'Send SMS to participants listed in the table below',
    sms_text: 'SMS text',
    sms_hint: 'This service is paid, $1 per SMS, max $2 characters',
    send: 'Send',
    sms_symbols_count: 'Number of characters: $1 / SMS: $2',
    sms_max_symbols: ' (maximum number of characters reached)',
    team_dnf: 'Did not finish',
    team_finish: 'Finished',
    female_short: 'F',
    male_short: 'M',
    loading_to_server: 'Image "$1" is uploading to the server...',
    image_added_to_selection: 'Image "$1" has been added to the logo selection options',
    sms_confirm_header: 'Confirmation of sending',
    sms_sent: 'SMS successfully sent!',
    sms_not_sent: 'Failed to send SMS: $1',
    sms_forbidden: 'Only the owner or the main organizer can send SMS',
    sms_canceled: 'Sending canceled',
    error_err: 'Error: $1',
    unknown_error: 'Unknown error',
    competitor_info: 'Add competitor info',
    load_earlier_races: 'Load earlier races',
    load_later_races: 'Load later races',
  }
};

export const translations_copy: TranslateArray = {
  ru: {
    name: 'Имя',
    ok: 'Сохранить',
    search_placeholder: 'Укажите номер участника для поиска',
    loading: 'Загрузка данных...',
    langs: 'Выберите перевод',
    all: 'Все',
    success: 'Успех',
  },
  us: {
    name: 'Full name',
    ok: 'Save',
    search_placeholder: `Please enter competitor's number to search`,
    loading: 'Loading data...',
  }
};
